module.exports = __webpack_public_path__ + "img/7749e38.jpg";